// External dependencies
import axios from 'axios';
/**
 * Axios client
 */
export const axiosClient = axios.create({
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});
